import { ApiClient } from "@quack.software/common";

export const api = ApiClient.instance(import.meta.env.VITE_API_HOST);
